import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'base-form';

@Component({
  selector: 'mfpc-select-filter',
  templateUrl: './select-filter.component.html',
  styleUrls: ['./select-filter.component.css'],
})
export class SelectFilterComponent extends BaseComponent implements OnChanges {
  optionLabel: string = 'title';

  @Input() options: any[] = [];

  private optionsLength: number = 0;

  get selectionLimit(): number {
    return this.item?.selectMultiple
      ? this.optionsLength
      : 1;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.optionsLength = this.options?.length || 0;

    if (this.options && Object.keys(this.options[0] || {}).includes('title')) {
      this.optionLabel = 'title';
    } else {
      this.optionLabel = 'representation';
    }
  }
}
